import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: 'application/json',
  },
  withCredentials: true,
  timeout: 30000, // 30 seconds
});

// Add a request interceptor to handle authentication
apiClient.interceptors.request.use(
  (config) => {
    const isFormData = config.data instanceof FormData;

    if (isFormData) {
      delete config.headers['Content-Type'];
    } else {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      console.error('Authentication required');
    }

    // Improve error logging for session-related issues
    if (error.config?.url?.includes('/session')) {
      console.error('Session API error:', {
        url: error.config.url,
        method: error.config.method,
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
      });
    }

    return Promise.reject(error);
  }
);

export default apiClient;
